export class FormTypeBase {
    fieldCode: string;  // 字段名
    labelKey: string;   // label的多语言key
    order: number;  // 排序
    type: string;   // 控件类型

    constructor(options: {
        type?: string,
        key?: string,
        fieldCode?: string,
        order?: number
    } = {}) {
        this.fieldCode = options.fieldCode || 'error';

        this.labelKey = `extension.${options.key || 'common'}.${options.fieldCode || 'error'}`;
        this.order = options.order === undefined ? 1 : options.order;
        this.type = options.type || 'text';
    }

    transform(val) {
        return val;
    }
}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/core/models/form/form-type-base.ts